module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "china-item"
  }, [_c('h2', [_c('img', {
    attrs: {
      "src": _vm.chinaImg2,
      "title": "文化传承"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "china-content-2",
    style: ({
      background: ("url(" + _vm.china2Bg + ")")
    }),
    attrs: {
      "id": "china-culture"
    }
  }, [_c('Carousel', {
    attrs: {
      "autoplay": _vm.setting.autoplay,
      "autoplay-speed": _vm.setting.autoplaySpeed,
      "dots": _vm.setting.dots,
      "radius-dot": _vm.setting.radiusDot,
      "trigger": _vm.setting.trigger,
      "arrow": _vm.setting.arrow
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.data), function(item, index) {
    return _c('CarouselItem', {
      key: index,
      staticClass: "img-item"
    }, [_c('router-link', {
      key: item.goodsId,
      attrs: {
        "to": {
          path: '/goods',
          query: {
            goods_id: item.goodsId
          }
        },
        "title": item.tip
      }
    }, [_c('img', {
      attrs: {
        "src": item.imgUrl
      }
    })])], 1)
  }), 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-063f7c6d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/china-time-honored/culture.vue
// module id = 1519
// module chunks = 1